import React, { useEffect, useState } from "react";
import { Row, Col, Container } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import ArrowIcon from "../assets/images/blue-arrow-right.svg";
import { Link } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import {
  clearMessages,
  fetchResources,
} from "../features/resource/resourceActions";
import { toast } from "react-toastify";
import { formatDate } from "../helpers/helpers";

function ResourcesList({ categorySlug }) {
  const dispatch = useDispatch();
  const { errorMessage, resources, loading } = useSelector(
    (state) => state.resource
  );


  // State to store all fetched resources
  const [allResources, setAllResources] = useState({});
  const [firstTab, setFirstTab] = useState("");

  useEffect(() => {
    let resourceCategoryId = "";
    if (categorySlug) {
      resourceCategoryId = categorySlug.split("-").pop();
    }
    let data = {
      page: 1,
      limit: 25,
      resource_category_id: resourceCategoryId,
      year: "",
    };
    dispatch(fetchResources(data));
  }, [dispatch, categorySlug]);

  useEffect(() => {
    setAllResources([]); // Clear all jobs
  }, []);

  useEffect(() => {
    if (resources?.data) {
      const groupedRecords = resources.data.reduce((acc, record) => {
        const { year } = record;
        if (!acc[year]) {
          acc[year] = [];
        }
        acc[year].push(record);
        return acc;
      }, {});

      const defaultYear = Object.keys(groupedRecords)[0] || null;
      setAllResources(groupedRecords);
      setFirstTab(defaultYear);
    }
  }, [resources]);

  useEffect(() => {}, [firstTab]);

  useEffect(() => {
    if (errorMessage) {
      toast.error(errorMessage, { autoClose: 3000, hideProgressBar: true });
      dispatch(clearMessages()); // Reset the messages after showing the toast
    }
  }, [errorMessage, dispatch]);

  return (
    <>
      <section className="resources-list">
        <Container>
          {firstTab && (
            <Row>
              <Col sm="12">
                <Tabs
                  defaultActiveKey={firstTab}
                  id="uncontrolled-tab-example"
                  className="mb-3"
                >
                  {Object.entries(allResources).map(([year, records]) => (
                    <Tab eventKey={year} title={year} key={year}>
                      <div className="resources-list-wrap">
                        {records.map((row, index) => (
                          <div
                            className="resources-list-item"
                            key={year + index}
                          >
                            <div className="resources-list-item-text">
                              <span>{formatDate(row.created_at)}</span>
                              <h2>{row.title}</h2>
                              <p>{row.category_title}</p>
                            </div>
                            <Link
                              to={"/resource-details/" + row.slug}
                              title="View Details"
                              className="custom-bttn view-bttn"
                            >
                              {" "}
                              View Details{" "}
                              <img
                                className="arrow-icon-img"
                                src={ArrowIcon}
                                alt=""
                              />
                            </Link>
                          </div>
                        ))}
                      </div>
                    </Tab>
                  ))}
                </Tabs>
              </Col>
            </Row>
          )}

          {!loading && firstTab === null && (
            <Row>
              <Col md="12" className="text-center">
                <p>No records found.</p>
              </Col>
            </Row>
          )}
        </Container>
      </section>
    </>
  );
}
export default ResourcesList;
